import React from 'react';
import { observer } from 'mobx-react-lite';


import { useHistoryItems } from './useHistoryItems';
import { AdminLayout } from '../../../../shared/admin/layout/AdminLayout';
import { CustomTable } from '../../../../shared/customTables/customTable/CustomTable';

export const HistoryItems = observer(() => {

  const {
    historyIsNotNull,
    cellsSwitcher,
    tableDataRows,
    headCells,
    addedContent
  } = useHistoryItems();

  return <AdminLayout>
    {historyIsNotNull &&
      <CustomTable searchBarAddedContent={addedContent} cellsSwitcher={cellsSwitcher} isSearchBar={true}
                   tableDataRows={tableDataRows} isDataDownloaded={true}
                   headCells={headCells}
      />}
  </AdminLayout>;
});